import { Link } from "react-router-dom";

import styled from "@emotion/styled";
import { Chip, Table, TableCell, TableRow } from "@mui/material";

const TableStyled = styled(Table)`
  min-width: 780px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    min-width: 1076px;
  }
`;

const TableRowOne = styled(TableRow)`
  & .MuiTableCell-root {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.secondary.gray};
    padding: 4px;

    @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
      font-size: 16px;
    }
  }
`;

const TableRowTwo = styled(TableRow)`
  & .MuiTableCell-root {
    font-weight: 500;
    padding: 14px 12px;

    font-size: 14px;

    @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
      font-size: 18px;
    }
  }
`;

export const CountryButton = styled.button`
  display: flex;
  align-items: center;
  padding: ${p => p.theme.space[3]}px;
  gap: ${p => p.theme.space[2]}px;
  font-size: 14px;
  color: ${p => p.theme.colors.secondary.gray};
  border-radius: ${p => p.theme.radii.small};
  background-color: ${p => p.theme.colors.background};
  cursor: pointer;
  border: none;

  transition:
    font-weight 0.3s ease,
    color 0.3s ease;

  &:hover {
    font-weight: ${p => p.theme.fontWeight.medium};
    color: ${p => p.theme.colors.black};
  }

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    font-size: 16px;
  }
`;

export const ChipStyled = styled(Chip)`
  font-weight: 500;
  font-size: ${p => p.theme.fontSizes.s};

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: ${p => p.theme.fontSizes.m};
  }
`;

const Text = styled.p`
  font-size: ${p => p.theme.fontSizes.s};
  font-weight: ${p => p.theme.fontWeight.medium};
  text-align: justify;
  line-height: normal;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 20px;
  }
`;

const TableCellStyled = styled(TableCell)`
  padding: 10px ${p => p.theme.space[4]}px !important;
`;

const Icon = styled.div`
  width: 20px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: ${p => p.theme.space[5]}px;
  gap: ${p => p.theme.space[5]}px;

  background-color: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.radii.normal};
`;

const IpWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const NoDataText = styled.p`
  padding: 12px 0;
  text-align: center;
`;

const CountryLink = styled(Link)`
  display: flex;
  gap: 10px;
  align-items: center;

  font-size: ${p => p.theme.fontSizes.s};
  line-height: 1.43;
  text-decoration: none;

  color: rgba(0, 0, 0, 0.8);
  cursor: default;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    font-size: ${p => p.theme.fontSizes.m};
    font-weight: ${p => p.theme.fontWeight.medium};
    line-height: normal;
  }
`;

export {
  CountryLink,
  TableStyled,
  TableRowOne,
  TableRowTwo,
  Text,
  TableCellStyled,
  Icon,
  TextWrapper,
  IpWrapper,
  NoDataText,
};
